export default __webpack_public_path__ + "static/media/G.292504f7.svg";